import { Snackbar } from "@mui/material";
import PlansList from "./list";

interface Props {
  plansList?: any;
  isLoading?: string;
  totalList?: any;
  loadMore?: any;
  suggested?: boolean;
  pageName?: any;
}

function Plans(props: Props) {
  const { plansList, isLoading, totalList, loadMore, suggested = false, pageName } = props;

  return (
    <>
      {isLoading === "failed" ? (
        <Snackbar open={true} autoHideDuration={6000} message="ERROR!!!" />
      ) : (
        <PlansList
          pageName={pageName}
          suggested={suggested}
          plansList={plansList}
          totalList={totalList}
          loadMore={loadMore}
        ></PlansList>
      )}
    </>
  );
}

export default Plans;
